import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'baseui/snackbar'

import { selectAuthData } from '@/containers/Login/AuthSelectors'
import useDevTools from '@/containers/DevToolsNew/shared/useDevTools'
import { showSnackbar, SNACKBAR_TYPES } from '@/shared/tools/notifications/notification'

import { betaFeaturesActions } from './betaFeaturesSagas'
import { selectBetaFeaturesTools } from './betaFeaturesSelectors'
import { cancelRemoval } from './betaFeaturesSlice'
import { canManageBetaFeatures } from './canManageBetaFeatures'
import { BetaFeaturesAuthData } from './types'

const useBetaFeatures = () => {
  const dispatch = useDispatch()
  const { enqueue } = useSnackbar()
  const { t } = useDevTools()
  const authData: BetaFeaturesAuthData = useSelector(selectAuthData) ?? {}
  const { isLoading, error, features, pendingRemoval } = useSelector(selectBetaFeaturesTools)
  const isAllowed = canManageBetaFeatures(authData)

  useEffect(() => {
    if (isAllowed) dispatch({ type: betaFeaturesActions.LOAD })
  }, [isAllowed])

  return {
    t,
    isAllowed,
    isLoading,
    error,
    features,
    isEmpty: !isLoading && !error && features.length === 0,
    isRemovalOpen: pendingRemoval !== null,
    removalText: t('beta_features.remove_confirm', { name: pendingRemoval?.name ?? '' }),
    onCancelRemoval: () => {
      dispatch(cancelRemoval())
    },
    onConfirmRemoval: () => {
      if (!pendingRemoval) return
      dispatch({
        type: betaFeaturesActions.REMOVE_TESTER,
        feature: pendingRemoval.feature,
        userId: pendingRemoval.userId,
        enqueue,
        onSuccess: () => showSnackbar(enqueue, { type: SNACKBAR_TYPES.SUCCESS, message: t('beta_features.removed') }),
      })
    },
  }
}

export default useBetaFeatures
